import { format } from 'date-fns';
import { toJSDate } from './timestampUtils';

export const formatDate = (date) => {
  const jsDate = toJSDate(date);
  if (!jsDate) return '';
  return format(jsDate, 'MMM dd, yyyy');
};

export const formatTimeString = (timeString) => {
  try {
    // Handle Date objects from TimePicker
    if (timeString instanceof Date) {
      return format(timeString, 'h:mm aa').toLowerCase();
    }

    // Handle string format
    if (typeof timeString === 'string') {
      // If already in correct format, return as is
      if (timeString.toLowerCase().includes('am') || timeString.toLowerCase().includes('pm')) {
        return timeString.toLowerCase();
      }

      // Parse time string (like "09:00" or "17:00")
      const [hours, minutes] = timeString.split(':').map(Number);
      const date = new Date();
      date.setHours(hours, minutes);
      return format(date, 'h:mm aa').toLowerCase();
    }

    throw new Error(`Invalid time format: ${timeString}`);
  } catch (err) {
    console.error('Error formatting time:', err);
    return '12:00 pm'; // Default fallback
  }
};

export const isValidDate = (date) => Boolean(toJSDate(date));

export const getStatusColor = (status) => {
  switch (status) {
    case 'confirmed': return 'success';
    case 'pending': return 'warning';
    case 'cancelled': return 'error';
    default: return 'default';
  }
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

export const createSlug = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

/** Capitalize status for display (e.g. "completed" -> "Completed", "no show" -> "No Show"). */
export const formatStatusLabel = (status) => {
  if (status == null || status === '') return '';
  return String(status)
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/** URL-safe 8-char slug for archive links (e.g. x7Kp2mQq). */
export const generateShortSlug = () => {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const bytes = typeof crypto !== 'undefined' && crypto.getRandomValues
    ? crypto.getRandomValues(new Uint8Array(8))
    : Array.from({ length: 8 }, () => Math.floor(Math.random() * 256));
  return Array.from(bytes, (b) => chars[b % chars.length]).join('');
};